function searchProducts(){

    var search_w = this.value;
    if(search_w.length>0){

        $.ajax({
            url: '/search',
            data: {
                type: 'product',
                view: 'json',
                q: search_w + '\*',
                prefix: 'last'
            },
            success: function (dataHTML) {
                 $('.search-menu-no-results').hide();
                 $('.search-menu-results-row').html(dataHTML);
                 var results_count = $('#results_count').val();
                 $('.search-count').text(results_count + " Results");
                 if(results_count==0) {
                     $('.search-menu-no-results').show();
                     $('.search-menu-results-row').empty();
                 }else{
                    setVariantIDPLP();
                    initVariantColorPLP();
                 }
            }
        });


    }else{
        $('.search-menu-results-row').empty();
        $('.search-count').text("0 Results");
        $('.search-menu-no-results').show();
    }
}

$(document).ready(function(){
    var elResult = document.getElementById('searchinput');
    elResult.addEventListener('keyup', searchProducts);
});
